import React from 'react';
import PropTypes from 'prop-types';
import './GraphRepresentation.scss';
import GraphView from './graphView';

const GraphRepresentation = ({ chartData }) => {

  return (
    <div className="charts-grid">
      <div className="chart-card">
        <div className="chart-placeholder">
          <h3 className="chart-title">Count of projects based on Primary Reasons</h3>
          <div className="chart-body">
            <GraphView
              projectDetails={chartData.primaryReasons}
            />
          </div>
        </div>
      </div>

      <div className="chart-card">
        <div className="chart-placeholder">
          <h3 className="chart-title">Count of projects based on Secondary Reasons</h3>
          <div className="chart-body">
            <GraphView
              projectDetails={chartData.secondaryReasons}
            />
          </div>
        </div>
      </div>

      <div className="chart-card">
        <div className="chart-placeholder">
          <h3 className="chart-title">Count of projects based on Actual Deviation</h3>
          <div className="chart-body">
            <GraphView
              projectDetails={chartData.actualDeviation}
            />
          </div>
        </div>
      </div>

      <div className="chart-card">
        <div className="chart-placeholder">
          <h3 className="chart-title">Count of projects based on Estimated Deviation</h3>
          <div className="chart-body">
            <GraphView
              projectDetails={chartData.estimatedDeviation}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

GraphRepresentation.propTypes = {
  chartData: PropTypes.shape({
    actualDeviation: PropTypes.array.isRequired,
    estimatedDeviation: PropTypes.array.isRequired,
    primaryReasons: PropTypes.array.isRequired,
    secondaryReasons: PropTypes.array.isRequired,
  }).isRequired,
};

export default GraphRepresentation;
